import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
// @ts-ignore
import Point from "../../geo/point";
import { indexTouches } from "../handler_util";
function getCentroid(points) {
  var sum = new Point(0, 0);
  var _iterator = _createForOfIteratorHelper(points),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var point = _step.value;
      sum._add(point);
    }
    // @ts-ignore
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return sum.div(points.length);
}
export var MAX_TAP_INTERVAL = 500;
export var MAX_TOUCH_TIME = 500;
export var MAX_DIST = 30;
var SingleTapRecognizer = /*#__PURE__*/function () {
  function SingleTapRecognizer(options) {
    _classCallCheck(this, SingleTapRecognizer);
    this.reset();
    this.numTouches = options.numTouches;
  }
  _createClass(SingleTapRecognizer, [{
    key: "reset",
    value: function reset() {
      // @ts-ignore
      delete this.centroid;
      // @ts-ignore
      delete this.startTime;
      // @ts-ignore
      delete this.touches;
      this.aborted = false;
    }
  }, {
    key: "touchstart",
    value: function touchstart(e, points, mapTouches) {
      if (this.centroid || mapTouches.length > this.numTouches) {
        this.aborted = true;
      }
      if (this.aborted) {
        return;
      }
      if (this.startTime === undefined) {
        this.startTime = e.timeStamp;
      }
      if (mapTouches.length === this.numTouches) {
        this.centroid = getCentroid(points);
        this.touches = indexTouches(mapTouches, points);
      }
    }
  }, {
    key: "touchmove",
    value: function touchmove(e, points, mapTouches) {
      if (this.aborted || !this.centroid) {
        return;
      }
      var newTouches = indexTouches(mapTouches, points);
      for (var id in this.touches) {
        if (this.touches[id]) {
          var prevPos = this.touches[id];
          var pos = newTouches[id];
          if (!pos || pos.dist(prevPos) > MAX_DIST) {
            this.aborted = true;
          }
        }
      }
    }
  }, {
    key: "touchend",
    value: function touchend(e, points, mapTouches) {
      if (!this.centroid || e.timeStamp - this.startTime > MAX_TOUCH_TIME) {
        this.aborted = true;
      }
      if (mapTouches.length === 0) {
        var centroid = !this.aborted && this.centroid;
        this.reset();
        if (centroid) {
          return centroid;
        }
      }
    }
  }]);
  return SingleTapRecognizer;
}();
export { SingleTapRecognizer as default };